import React, { Suspense } from 'react'
import { Loading } from '../index.js'

const SuspenseComponent = ({ children }) => {
    return <Suspense fallback={<Loading />}>
        {children}
        </Suspense>
}

export default SuspenseComponent